//This provides a source to backend and by default it will return Store.

export function sourceIdentifier(selectedSource: string = "store") {
  const store = 5; // default
  const source = {
    email: 1,
    whatsapp: 2,
    sms: 3,
    invoice: 4,
    store: 5,
    web: 6,
    apps: 7,
  };
  return source[selectedSource] ? source[selectedSource] : store;
}
